import React, { useContext, useEffect, useState } from 'react';
import {
  EventEmitter,
  UnknownTicketActions,
  withErrorBoundary,
  toast
} from '@nile/components';
import { useMutation } from '@apollo/client';
import envConfig from '@nile/home/src/Config/env';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { SVGIcon } from '@superops/super-icons';
import { Button, DisplayText, TextStyle } from '@superops/ui-design-system';
import { FormattedMessage } from 'react-intl';
import UnspamTicketButton from '@nile/mangifera/src/Components/Ticket/UnspamTicketButton.tsx';
import { HARD_TICKET_DELETE, RESTORE_TICKETS } from '@nile/graphql';

const TicketStateCard = (props) => {
  const { ticket, refetchTicket } = props;
  const [cardType, setCardType] = useState(props?.cardType);
  const context = useContext(TicketContext);

  const [
    restoreTickets,
    { loading: restoring, error: restoreError }
  ] = useMutation(RESTORE_TICKETS, {
    onCompleted({ restoreTickets }) {
      if (restoreTickets) {
        toast('success', 'toast.tickets.list.restore.success');
        refetchTicket && refetchTicket();
      }
    }
  });

  const [
    hardDeleteTickets,
    { loading: deleting, error: deleteError }
  ] = useMutation(HARD_TICKET_DELETE, {
    onCompleted({ hardDeleteTickets }) {
      if (hardDeleteTickets) {
        toast('success', 'toast.tickets.list.hardDelete.success');
      }
    }
  });

  const getCardType = () => {
    if (
      (ticket?.dormantType === 'DELETED' &&
        ticket?.operationalStatus === 'DORMANT') ||
      ticket?.dormantType === 'SPAM'
    ) {
      return ticket?.dormantType;
    }

    if (!ticket?.client && ticket.dormantType !== 'DELETED') {
      return 'UnknownTicket';
    }

    if (ticket?.operationalStatus === 'DORMANT') {
      return 'DELETED';
    }
  };

  useEffect(() => {
    if (!props?.cardType) {
      const cardTypeData = getCardType();
      setCardType(cardTypeData);
    }
  }, []);

  useEffect(() => {
    setCardType(props?.cardType);
  }, [props?.cardType]);

  const restoreTicket = () => {
    restoreTickets({
      variables: { ids: [ticket.ticketId] }
    }).then((res) => {
      EventEmitter.dispatch('currentTicketRestored', ticket.ticketId);
    });
  };

  const hardDeleteTicket = () => {
    hardDeleteTickets({
      variables: { ids: [ticket.ticketId] }
    }).then((res) => {
      EventEmitter.dispatch('refetchClassicViewList');
    });
  };

  let footer = null;
  let headerText = null;

  switch (cardType) {
    case 'UnknownTicket':
      headerText = <FormattedMessage id="ticket.unknown.associate.message" />;
      footer = (
        <UnknownTicketActions
          ticket={ticket}
          associationSuccess={() => {
            EventEmitter.dispatch('refetchClassicViewList');
          }}
          deletionSuccess={() => {
            EventEmitter.dispatch('refetchClassicViewList');
          }}
          isClassicView
        />
      );
      break;
    case 'DELETED':
      headerText = <FormattedMessage id="toast.ticket.softdelete.success" />;
      footer = (
        <div className="col flex gap-10 mt-20">
          <Button icon={<SVGIcon name="Restore" />} onClick={restoreTicket}>
            <div className="flex g2">
              <span>
                <FormattedMessage id="client.view.restore.button" />
              </span>
              <span>
                <FormattedMessage id="common.ticket" />
              </span>
            </div>
          </Button>

          <div className="flex">
            <div className="flex mauto ptr g5" onClick={hardDeleteTicket}>
              <SVGIcon name="Delete" color="#C14136" />
              <TextStyle variation="negative">
                <FormattedMessage id="client.view.delete.button" />
              </TextStyle>
            </div>
          </div>
        </div>
      );

      break;
    case 'SPAM':
      headerText = <FormattedMessage id="ticket.spam.success.toast" />;
      footer = (
        <div className="mt10">
          <UnspamTicketButton
            inputVariables={{
              ticket: [{ ticketId: ticket.ticketId }],
              unspamRequester: true
            }}
            onCompleted={() => {
              EventEmitter.dispatch('refetchTicketFromAI');
            }}
            showWarning
          />
        </div>
      );
      break;
    default:
      return <></>;
  }

  return (
    <div className="bg-white">
      <div
        className={`${cardType === 'UnknownTicket' &&
          'm10'} mauto background-classic-gradient border-radius-md col flex center p20 text-align-centr`}
      >
        <div className="mb-20">
          <img src={`${envConfig.imageRoot}svg/classicguy.svg`} alt="loading" />
        </div>
        <DisplayText element="h3" weight="SemiBold">
          {headerText}
        </DisplayText>
        {footer}
      </div>
    </div>
  );
};

export default withErrorBoundary(TicketStateCard);
